import { RouteFactory } from "@app/routePaths";

/**
 * component to render in steps to apply tab at How to Nominate page EE
 */
const StepsToApply = (): React.ReactElement => {
  return (
    <div
      className="mb-5 bg-gray-150 p-4 font-public-sans"
      data-testid="steps-to-apply-component"
    >
      <p className="mb-12">
        Download Application Form&nbsp;
        <a
          href={RouteFactory.eeApplyNowPage}
          className="font-bold text-blue-175 underline"
        >
          here
        </a>
        .
      </p>

      <p>
        For more information, check out the&nbsp;
        <a
          href={RouteFactory.eeFaqPage}
          className="font-bold text-blue-175 underline"
        >
          FAQs
        </a>
        .
      </p>
    </div>
  );
};

export default StepsToApply;
